'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/asyncToGenerator");

var AggregateError = require('aggregate-error');

module.exports = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(iterable, mapper) {
    var _ref2,
        _ref2$concurrency,
        concurrency,
        _ref2$stopOnError,
        stopOnError,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref2 = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {}, _ref2$concurrency = _ref2.concurrency, concurrency = _ref2$concurrency === void 0 ? Infinity : _ref2$concurrency, _ref2$stopOnError = _ref2.stopOnError, stopOnError = _ref2$stopOnError === void 0 ? true : _ref2$stopOnError;
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              if (typeof mapper !== 'function') {
                throw new TypeError('Mapper function is required');
              }

              if (!((Number.isSafeInteger(concurrency) || concurrency === Infinity) && concurrency >= 1)) {
                throw new TypeError("Expected `concurrency` to be an integer from 1 and up or `Infinity`, got `".concat(concurrency, "` (").concat(typeof concurrency, ")"));
              }

              var result = [];
              var errors = [];
              var iterator = iterable[Symbol.iterator]();
              var isRejected = false;
              var isIterableDone = false;
              var resolvingCount = 0;
              var currentIndex = 0;

              var next = function next() {
                if (isRejected) {
                  return;
                }

                var nextItem = iterator.next();
                var index = currentIndex;
                currentIndex++;

                if (nextItem.done) {
                  isIterableDone = true;

                  if (resolvingCount === 0) {
                    if (!stopOnError && errors.length !== 0) {
                      reject(new AggregateError(errors));
                    } else {
                      resolve(result);
                    }
                  }

                  return;
                }

                resolvingCount++;

                _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var element;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return nextItem.value;

                        case 3:
                          element = _context.sent;
                          _context.next = 6;
                          return mapper(element, index);

                        case 6:
                          result[index] = _context.sent;
                          resolvingCount--;
                          next();
                          _context.next = 14;
                          break;

                        case 11:
                          _context.prev = 11;
                          _context.t0 = _context["catch"](0);

                          if (stopOnError) {
                            isRejected = true;
                            reject(_context.t0);
                          } else {
                            errors.push(_context.t0);
                            resolvingCount--;
                            next();
                          }

                        case 14:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 11]]);
                }))();
              };

              for (var i = 0; i < concurrency; i++) {
                next();

                if (isIterableDone) {
                  break;
                }
              }
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();